/* The five eligible org kinds per CA WIC §5961.4 + "Other" escape hatch.
   Server-side validation mirrors this list in 002_org_rpc.sql — keep them
   in sync. */
export const ORG_KINDS = [
  { id: 'LEA',     label: 'Local Education Agency (LEA)' },
  { id: 'COE',     label: 'County Office of Education (COE)' },
  { id: 'IHE',     label: 'Institution of Higher Education (IHE)' },
  { id: 'Charter', label: 'Charter school / network' },
  { id: 'Other',   label: 'Other (state special school, etc.)' },
] as const;

export type OrgKind = (typeof ORG_KINDS)[number]['id'];
